module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_7005.7aab3a0e.png";